// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as IncentivesRepoConfig from "./IncentivesRepoConfig.bs.js";

var dummyIncentive = {
      "campaigns": [
        {
          "campaign_id": "0",
          "start_date": 1669746600000,
          "end_date": 1672338600000,
          "incentive_parameters": {
            "completed_trips": 10,
            "abrtg_allowed": 2,
            "missed_order_allowed": 3,
            "fraud_allowed": 0,
          },
        },
      ],
    };

var dummyCampaignOrders = {
      "orders": [
        {
          "order_id": "1234567",
          "order_type": "MISSED",
          "order_date": 1669746600000,
        }
      ]
    };

function fetchIncentives(_msisdn, _offset, param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyIncentive
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(IncentivesRepoConfig.IncentivesResponseConverter.execute, result);
                        });
            });
}

function fetchCampaignOrders(_campaign_id, _msisdn, param) {
  return new Promise((function (resolve, param) {
                  return resolve({
                              TAG: /* Success */0,
                              _0: dummyCampaignOrders
                            });
                })).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(IncentivesRepoConfig.CampaignOrdersResponseConverter.execute, result);
                        });
            });
}

var IncentivesRepo = {
  dummyIncentive: dummyIncentive,
  dummyCampaignOrders: dummyCampaignOrders,
  fetchIncentives: fetchIncentives,
  fetchCampaignOrders: fetchCampaignOrders
};

export {
  IncentivesRepo ,
  
}
/* IncentivesRepoConfig Not a pure module */
